/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoolMiningCommissionItem } from './pool-mining-commission-item';


export interface PoolMiningCommissionsResponse { 
    items: Array<PoolMiningCommissionItem>;
}

